import React from "react";

const About = () => {
  return (
    <div className=" flex justify-center">
      <div className=" flex justify-center flex-col gap-6 md:w-10/12 w-full md:px-0 px-4 pb-5 md:pt-24 pt-16">
        <div className="div">
          <h1 className=" md:text-3xl text-2xl text-black font-bold">
            ABOUT US.
          </h1>
          <h2>
            Brocade is a Nepali clothing fashion brand that aims to bring the
            essence of Nepali culture and tradition to its fashion line. The
            brand is committed to preserving the rich heritage of Nepali
            clothing and textiles while infusing contemporary designs to cater
            to the modern fashion sensibilities of its customers. Brocade
            clothing line is inspired by the vibrant colors and intricate
            patterns that are characteristic of Nepali textiles. Each garment is
            crafted with precision and care, using high-quality materials that
            ensure both durability and comfort. From traditional sarees and
            kurtas to modern , Brocade offers a diverse range of clothing
            options that cater to every occasion.
          </h2>
        </div>
        <div>
          With a deep-rooted commitment to sustainability, Brocade sources its
          materials from local artisans and weavers, supporting the traditional
          craft community of Nepal. The brand also incorporates eco-friendly
          practices into its production process, ensuring that its products have
          a minimal environmental impact. Brocade mission is to promote the rich
          Nepali textile heritage and make it accessible to the global
          community. By offering a unique blend of traditional and modern
          designs, the brand aims to create a fashion identity that is both
          timeless and contemporary.
        </div>
        <div>
          <h1 className=" md:text-2xl text-xl text-black font-semibold">
            What we do ?
          </h1>
          <h2>
            At Brocade, we design and create clothing that reflects the rich
            cultural heritage of Nepal, while also catering to the modern
            fashion sensibilities of our customers. We specialize in creating
            unique and vibrant garments that are inspired by the traditional
            textile patterns of Nepal, with a focus on quality, comfort, and
            sustainability. Our clothing line is carefully crafted to ensure
            that each garment is not only aesthetically pleasing.
          </h2>
        </div>
        <div>
          Our range of clothing options includes traditional sarees, kurtas, and
          fusion wear, as well as contemporary designs that blend traditional
          and modern elements. We also offer customized designs to meet the
          specific needs and preferences of our customers. At Brocade, we are
          committed to promoting the Nepali textile industry and supporting the
          traditional craft community of Nepal. We work closely with local
          artisans and weavers, providing them with a platform to showcase their
          skills and expertise, and ensuring that their contributions are
          recognized. 
        </div>
        <div>
          <h1 className=" md:text-2xl text-xl text-black font-semibold">
            Our Vision and Goals.
          </h1>
          <h2>
            At Brocade, our aim is to promote and preserve the rich cultural
            heritage of Nepal through our clothing line. We believe that the
            traditional textile patterns and designs of Nepal are a valuable
            part of our cultural identity, and we are committed to bringing them
            to the forefront of the global fashion industry. We aim to create a
            unique and vibrant fashion identity that celebrates the diversity
            and richness of Nepali culture. Through our designs, we strive to
            showcase the beauty and intricate details of traditional Nepali.
          </h2>
        </div>
        <div className="div">
          Our focus on sustainability is a core part of our aim, as we are
          committed to reducing our environmental impact and supporting the
          local artisan and weaver communities. We work closely with these
          communities, providing them with a platform to showcase their skills
          and expertise, and ensuring that they receive fair compensation for
          their work. Ultimately, our aim is to create a clothing line that is
          both beautiful.
        </div>
        <div className=" flex flex-col gap-6">
          <div>
            <h1 className=" md:text-2xl text-xl text-black font-semibold">
              Our Impacts.
            </h1>
            <h2>
              1. Cultural preservation: By promoting traditional Nepali textiles
              and designs, we are helping to preserve and celebrate the rich
              cultural heritage of Nepal. Our clothing line reflects the beauty
              and intricacy of traditional Nepali textiles, ensuring that these
              designs remain relevant and valued.
            </h2>
          </div>
          <h1>
            2. Sustainability: We are committed to reducing our environmental
            impact by sourcing materials from local artisans and weavers and
            employing eco-friendly production methods. By doing so, we are
            supporting the local economy and minimizing our carbon footprint.
          </h1>
          <h1>
            3. Community support: We work closely with local artisans and
            weavers, providing them with fair compensation for their work and
            helping to promote their skills and expertise. By supporting these
            communities, we are helping to preserve traditional Nepali.
          </h1>
          <h1>
            5. Social responsibility: We are committed to ethical business
            practices and transparency in all our operations. We believe in
            creating a positive impact on the world around us and strive to make
            a difference through our clothing line.
          </h1>
        </div>
      </div>
    </div>
  );
};

export default About;
